import { Injectable, HostListener } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

// Menu
export interface Menu {
	path?: string;
	title?: string;
	type?: string;
	megaMenu?: boolean;
	image?: string;
	active?: boolean;
	badge?: boolean;
	badgeText?: string;
	children?: Menu[];
}

@Injectable({
	providedIn: 'root'
})

export class NavService {

	constructor() { }

	public screenWidth: any;
	public leftMenuToggle: boolean = false;
	public mainMenuToggle: boolean = false;

	// Windows width
	@HostListener('window:resize', ['$event'])
	onResize(event?) {
		this.screenWidth = window.innerWidth;
	}

	MENUITEMS: Menu[] = [
		{ title: 'Inicio', type: 'link', path: '/home', active: false },
		//{ title: 'Acerca de mi', type: 'link', path: '/pages/aboutus', active: false },
		{ title: 'blog', type: 'link', path: '/pages/blog', active: false },		
		// {
		// 	title: 'Sevicios', type: 'sub', active: false, children: [
		// 		{ path: '/pages/aboutus', title: 'Ontológico', type: 'link' },
		// 		{ path: '/pages/aboutus', title: 'Vocacional', type: 'link' },
		// 		{ path: '/pages/aboutus', title: 'Ejecutivo', type: 'link' },
		// 		{ path: '/pages/aboutus', title: 'Deportivo', type: 'link' },
		// 		{ path: '/pages/aboutus', title: 'Triangulación', type: 'link' },
		// 	]
		// },
		// {
		// 	title: 'Cursos', type: 'sub', active: false, children: [
		// 		{
		// 			title: 'sidebar', type: 'sub', active: false, children: [
		// 				{ path: '/shop/product/left/sidebar/trim-dress', title: 'left-sidebar', type: 'link' },
		// 				{ path: '/shop/product/right/sidebar/trim-dress', title: 'right-sidebar', type: 'link' },
		// 				{ path: '/shop/product/no/sidebar/trim-dress', title: 'no-sidebar', type: 'link' }
		// 			]
		// 		},
		// 		{ path: '/shop/product/three/column/trim-dress', title: 'three-column', type: 'link' },
		// 		{ path: '/shop/product/four/image/belted-dress', title: 'four-image', type: 'link' },
		// 		{ path: '/shop/product/bundle/trim-dress', title: 'bundle-product', type: 'link' },
		// 		{ path: '/shop/product/image/outside/trim-dress', title: 'image-outside', type: 'link' }
		// 	]
		// },
		//{ title: 'Agendar Sesión', type: 'link', path: '/pages/aboutus', active: false },		
		{ title: 'Agendar Sesión', type: 'link', path: '', active: false },		
		{ title: 'Contacto', type: 'link', path: '/pages/contact', active: false },	
	];

	

	// Array
	items = new BehaviorSubject<Menu[]>(this.MENUITEMS);

}
